import { isSayWeeeApp } from '@/utils/common/device';
import { useEffect } from 'react';
import Constants from '@/constants/const';
import { setCookie, getCookie } from '@/utils/cookie';

const usePageResume = () => {
  useEffect(() => {
    if (isSayWeeeApp()) {
      window['onPageResume'] = data => {
        [Constants.REFERRER_PAGE_URL, Constants.REFERRER_PAGE_KEY, Constants.VIEW_ID].forEach(key => {
          sessionStorage?.removeItem?.(key);
        });
        let context = JSON.parse(data?.[Constants.APP_CONTEXT] || '{}');
        setCookie(
          Constants.APP_CONTEXT,
          JSON.stringify({
            page_key: context.page_key,
            page_url: context.page_url,
            view_id: context.view_id,
            referer_page_key: context.referer_page_key,
            referer_page_url: context.referer_page_url,
            referer_view_id: context.referer_view_id,
            referer_page_ctx_app: context.referer_page_ctx_app
          }),
          {}
        );
        let _pageContext = window._weeeTracker?.pageContext || {};
        _pageContext.page_urls = [];
        _pageContext.page_keys = [];
        _pageContext.view_ids = [];
        if (context.view_id) {
          _pageContext.addPage?.(context.page_url, context.page_key, context.view_id);
        }
        _pageContext.init?.();
        window._weeeTracker?.trackPageView?.();
        document.dispatchEvent(
          new CustomEvent('onPageResume', {
            detail: data
          })
        );
      };
    }
  }, []);
};

export default usePageResume;
